import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_SEARCH_PAGE } from "../graphql/queries";
import { Link } from "react-router-dom";
import { ROUTES } from "../routes/routes";

export default function Search() {
    const { slug } = useParams();
    const { loading, error, data } = useQuery(GET_SEARCH_PAGE, {
        variables: { slug },
    });
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    if (
        !data ||
        ((!data.blogs || data.blogs.length === 0) &&
            (!data.portfolios || data.portfolios.length === 0))
    ) {
        return <p>No project found.</p>;
    }

    const blogs = data.blogs || [{ slug }];
    const portfolios = data.portfolios || [{ slug }];

    console.log(loading, error, data);

    return (
        <div className="main-container">
            <div className="search-header">
                <h2>Search Results for: {slug}</h2>
                <div className="search">
                    <h3>Blogs</h3>
                    {blogs.map((post) => (
                        <Link
                            to={`${ROUTES.blog.path}/${post.slug}`}
                            key={`blog-${post.slug}`}
                        >
                            <div key={post.id} className="search-item">
                                <div className="search-content">
                                    <div className="search-text">
                                        <h4>{post.title}</h4>
                                    </div>
                                    <p>Blog</p>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
            <div className="search">
                <h3>Portfolios</h3>
                {portfolios.map((post) => (
                    <Link
                        to={`${ROUTES.project.path}/${post.slug}`}
                        key={`blog-${post.slug}`}
                    >
                        <div key={post.id} className="search-item">
                            <div className="search-content">
                                <div className="search-text">
                                    <h4>{post.title}</h4>
                                </div>
                                <p>Portfolio</p>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
